import { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useUserStore } from '@/stores/user';

interface ProtectedRouteProps {
  children: ReactNode;
}

// Gate a route on authentication. Not used by any route yet, but ready for
// future logged-in-only pages. Waits for the initial hydrate() to resolve so it
// doesn't flash-redirect to /login on reload before the cookie probe finishes.
function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useUserStore((s) => s.isAuthenticated);
  const hydrated = useUserStore((s) => s.hydrated);

  if (!hydrated) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100dvh - 65px)'
        }}
      >
        <ProgressSpinner />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default ProtectedRoute;
